import type { SaveBarStatus } from "./save-bar.type";

import { SAVE_BAR_STATUS } from "./save-bar.enum";

export const getSaveBarStatus = (hasChanges?: boolean): SaveBarStatus => {
  if (hasChanges === true) return SAVE_BAR_STATUS.WARNING;
  if (hasChanges === false) return SAVE_BAR_STATUS.SUCCESS;
  return SAVE_BAR_STATUS.DEFAULT;
};
